module.exports = __webpack_public_path__ + "img/zanwu_baise3.dfdaee47.png";